import {
  GET_XDPS_FULFILLED,
  SELECT_XDP,
  GET_XDP_PENDING,
  GET_XDP_FULFILLED,
  XdpActionTypes,
  XdpState,
} from './xdp.types';
import { adaptXdpList, adaptSelectedXdp, adaptFromServerFormat } from './xdp.adapter';

const initialState: XdpState = {
  entities: [],
  select: [],
  single: null,
};

export default function xdpReducer(
  state = initialState,
  action: XdpActionTypes,
): XdpState {
  switch (action.type) {
    case GET_XDPS_FULFILLED:
      return { ...state, entities: adaptXdpList(action.payload.data.data || []) };

    case SELECT_XDP:
      return { ...state, select: adaptSelectedXdp(action.payload || []) };

    case GET_XDP_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_XDP_FULFILLED:
      return {
        ...state,
        single: adaptFromServerFormat((action.payload.data.data ?? [])[0]),
      };

    default:
      return state;
  }
}
